import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import 'rxjs/Rx';
@Injectable({
  providedIn: 'root'
})

export class NewsService {

  constructor(
    private http: HttpClient
  ) { }

  public newsId = "";
  public action = "";
  private options = { headers: new HttpHeaders().set('isUpload', 'true') };
  GetAllNewsDetails(){
    return this.http.get(environment.apiURL + `news/GetAllNewsDetails?IsActive=true`);
  }
  GetAllNewsDetailsByCreatedDate(date){
    return this.http.get(environment.apiURL + `news/GetAllNewsDetails?IsActive=true&CreatedOn=`+date);
  }
  GetAllNewsDetailsByDateWise(fromdate,todate){
    return this.http.get(environment.apiURL + `news/GetAllNewsDetails?IsActive=true&FromDate=`+fromdate+`&ToDate=`+todate);
  }
  GetNewsDetailsById(newsId){
    return this.http.get(environment.apiURL + `news/GetAllNewsDetails?_id=`+newsId);
  }
  GetCompetitor(){
    return this.http.get(environment.apiURL + `company/GetCompany?Isactive=true`);
  }
  GetIndustry(){
    return this.http.get(environment.apiURL + `master/GetIndustry`);
  }  

  GetCompanyNames(){
    return this.http.get(environment.apiURL + `company/GetCompany?Isactive=true`);
  }
  GetCategorization(){
    return this.http.get(environment.apiURL + `master/GetCategorization`);
  }
  GetIndication(){
    return this.http.get(environment.apiURL+`master/GetIndication`);
  }
  
  GetAllProductDetails(){
    return this.http.get(environment.apiURL+`product/GetAllProductDetails`);
  }
  AddNews(data){
    return this.http.post(environment.apiURL + `news/AddNews`, data);
  }
  UpdateNews(data){
    return this.http.post(environment.apiURL + `news/UpdateNews`, data);
  }
  DeleteNews(data){
    return this.http.post(environment.apiURL + `news/DeleteNews`, data);
  }
  UploadNewsImage(formData){    
    return this.http.post(environment.apiURL + `news/UploadNewsImage`, formData, this.options);
  }
  UploadNewsAttachment(formData){    
    return this.http.post(environment.apiURL + `news/UploadNewsAttachment`, formData, this.options);
  }
  getImage(imageUrl: string) {
    return this.http.get(imageUrl, {observe: 'response', responseType: 'blob'})
      .map((res) => {
        return new Blob([res.body], {type: res.headers.get('Content-Type')});
      })
  }

  GetUserNews(data){
    return this.http.post(environment.apiURL + `news/GetUserNews`, data);
  }
  GetSharedNewsDetailsById(newsId){
    return this.http.get(environment.apiURL + `news/GetSharedUserNews?_id=`+newsId);
  }
  SendSharedNewsEmail(data){
    return this.http.post(environment.apiURL + `email/Send`, data);
  }
  GetUserProduct(data){
    return this.http.post(environment.apiURL + `product/GetUserProduct`, data);
  }
  GetNewsByTitle(title){
    return this.http.get(environment.apiURL + `news/GetAllNewsDetails?IsActive=true&Title=`+title);
  }

  searchQuestion(searchKey){
    return this.http.get(environment.apiURL + `qa/search?search=`+searchKey);
  }
}
